import React from "react";
import { Row, Col, Container, Media } from "reactstrap";
import Slider from "react-slick";
import myImage from '../../../resources/custom/images/customer_testimonial.jpg';

var settings = {
  autoplay: false,
  autoplaySpeed: 2500,
};

const Review = [
  {
    img: "/images/testimonial/1.jpg",
    user: "Sophia Martinez",
    review:
      "I purchased a gold necklace from Zimbole Days for my wedding, and it was absolutely stunning. The craftsmanship is so detailed, and I received so many compliments. Truly timeless pieces!"
  },
  {
    img: "/images/testimonial/2.jpg",
    user: "Arjun Mehta",
    review:
      "Zimbole Days has become my go-to for gifts. The quality of their diamonds and the elegant designs make every purchase special. Excellent service and fast delivery too."
  },
  {
    img: "/images/testimonial/3.jpg",
    user: "Emily Johnson",
    review:
      "I was amazed by the custom ring I ordered from Zimbole Days. They listened to my ideas and created something more beautiful than I imagined. It’s now my most treasured piece."
  }
];

const CustomerTestimonial = () => {
  return (
    <>
      {/* <section className="testimonial testimonial-inverse">
        <Container>
          <Row>
            <Col md="12">
              <div className="slide-1 no-arrow">
                <Slider {...settings}>
                  {Review.map((data, i) => (
                    <div key={i}>
                      <div className="testimonial-contain">
                        <div className="media">
                          <div className="testimonial-img">
                            <Media src={myImage} className="img-fluid rounded-circle" alt="testimonial" />
                          </div>
                          <div className="media-body">
                            <h5>{data.user}</h5>
                            <p>{data.review}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}
    </>
  );
};

export default CustomerTestimonial;
